import { fn, INamed } from '@common/utils';
import { Bind } from '@common/navkendo/kutils';
import { IPageMetaData, IPageProperty } from '../nav';
import { NavPropertyItem } from './navpropertyitem';
import { NavPropertyItems } from './navpropertyitems';
import { NavPropertyValue } from './navpropertyvalue';
import { Observable } from '@common/nav/navmodel';

const EV_SetCurrentItem = "SetCurrentItem";

/** Container of UI Connectors */
export class NavPropertyValues extends Observable {
    constructor(MetaData: IPageMetaData, currItem?: NavPropertyItem) {
        super();
        this.MetaData = MetaData;
        this.currItem = currItem;
    }
    public readonly MetaData: IPageMetaData;
    private propertyValues = <INamed<NavPropertyValue>>{};
    public get CurrentItem() { return this.currItem; }
    private currItem: NavPropertyItem;
    destroy() {
        this.SetCurrentItem(undefined);
        this.BindToContainerSelection(undefined);
        super.unbind(undefined);
    }
    /** GetPropertyValue by PropertyName or Property Item  */
    public GetPropertyValue(propItem: string | IPageProperty, throwError?: boolean) {
        var meta = this.MetaData, prop = meta && meta.ResolveProperty(propItem, throwError);
        if (!prop)
            return;
        let pVals = this.propertyValues, propName = prop.Name;
        return pVals[propName] || (pVals[propName] = new NavPropertyValue(prop, this.currItem));
    }
    public OnCurrentItemChanged(callback: () => void) {
        return Bind(this, callback, EV_SetCurrentItem);
    }
    /** Set Current Item for Display */
    public SetCurrentItem(item: NavPropertyItem) {
        if (this.currItem === item)
            return;
        this.currItem = item;
        this.trigger(EV_SetCurrentItem);
        fn.DictToArray(this.propertyValues).forEach(p => p.SetCurrentItem(item));
    }
    /** Bind Display to Selected Item of Container (i.e. call "SetCurrentItem" if selection of container changes) */
    public BindToContainerSelection(container: NavPropertyItems) {
        const evBindToContainer = "BindToContainer";
        this.trigger(evBindToContainer);
        if (!(container instanceof NavPropertyItems)) {
            this.SetCurrentItem(undefined);
            return;
        }
        var selItems = container.SelectedItems;
        if (selItems.length == 0 && container.Count > 0) {
            container.SetSelected(container.Items[0]);
        }
        var refreshCurrent = () => {
            var curr = selItems.length == 1 && selItems[0];
            this.SetCurrentItem(curr);
        };
        // Set Current From selected in container : on Selection Change +  initial
        this.one(evBindToContainer, container.RegisterSelectionChanged(refreshCurrent));
        refreshCurrent();
    }
}
